import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core'
import { POPUP_STATE, PopupContent, PopupService } from '@services/popup.service'

@Component({
    selector: 'inka-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: false
})
export class PopupComponent implements OnInit {
  @Input() message: string = 'Do you want to stop bladder training?'
  @Input() tense: boolean = false
  @Input() buttons: boolean = true

  @Output() accept: EventEmitter<any> = new EventEmitter<any>()
  @Output() decline: EventEmitter<any> = new EventEmitter<any>()

  constructor(public popup: PopupService) {
  }

  ngOnInit(): void {
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}

@Component({
    selector: 'inka-popup-container',
    template: '<ng-container #container></ng-container>',
    standalone: false
})
export class PopupContainerComponent {
  @ViewChild('container', { read: ViewContainerRef, static: true }) public container!: ViewContainerRef;

  @Input()
  public set content(content: PopupContent | null) {
    this.container.clear();
    if (content?.component) {
      const injector = Injector.create({
        providers: [{
          provide: POPUP_STATE,
          useValue: content.state
        }],
        parent: this.injector
      });
      this.container.createComponent(content.component, { injector: injector });
    }
  }

  constructor(private injector: Injector) { }
}